import { useInjection } from "@linkfluence/core/di";
import { ProjectRepo, ProjectRepositoryUID } from "../repositories/ProjectRepo";

export function useCurrentProject() {
  return useInjection<ProjectRepo>(ProjectRepositoryUID).getCurrentProject();
}
